import { useCheckoutContext } from "context/checkout-context";
import { CheckoutPaymentForm } from "..";
import { CheckoutPaymentSelector } from "components/UI/molecules";
import "./index.scss";

export const CheckoutPayment = () => {
  const {
    isFormOpen,
    setPaymentMethodErrorMessage,
    setDisableSubmitPayment,
    toggleForm
  } = useCheckoutContext();

  const handleFormToggle = () => {
    setPaymentMethodErrorMessage(null);
    setDisableSubmitPayment(!isFormOpen);
    toggleForm(!isFormOpen);
  };

  return (
    <div className="checkout-payment">
      <h2 className="payment-title">Payment</h2>
      {isFormOpen ? (
        <CheckoutPaymentForm toggleForm={handleFormToggle} />
      ) : (
        <CheckoutPaymentSelector toggleForm={handleFormToggle} />
      )}
    </div>
  );
};
